// extracted by mini-css-extract-plugin
module.exports = {"container":"Resequence_container__30xbR Layouts_containerWithoutSidebar__3w4p5"};